import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import { connect } from "react-redux";
import moneyFormatter from "../../common/moneyFormatter";
import "./style.scss";

class StackedBar extends Component {
  state = {
    colors: ["#7ab7e2", "#85ca46c4", "#ffca52c4", "#ff9528d1", "#4fda80"]
  };
  // data order should be bottom to up
  componentDidMount() {
    var { data, width } = this.props;
    this.createChart(data, width);
  }
  componentWillReceiveProps(nextProps) {
    var { data, width } = nextProps;
    if (
      JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) ||
      this.props.width !== nextProps.width
    ) {
      $(`#${this.props.id}`).empty();
      console.log(data, "data from component will receive props");
      this.createChart(data, width);
    }
  }
  createChart = (data, w) => {
    const { colors } = this.state;
    let arr = Object.keys(data[0]).filter(
      (d, i) => d !== "year" && d !== "title"
    );

    var margin = { top: 30, right: 50, bottom: 30, left: 20 },
      width = w - margin.left - margin.right,
      height = 400 - margin.top - margin.bottom;

    var x = d3.scale.ordinal().rangeRoundBands([0, width]);

    var y = d3.scale.linear().rangeRound([height, 0]);

    var xAxis = d3.svg
      .axis()
      .tickValues([])
      .outerTickSize(0)
      .scale(x)
      .orient("bottom");

    var yAxis = d3.svg
      .axis()
      .tickValues([])
      .outerTickSize(0)
      .scale(x)
      .orient("top");

    var svg = d3
      .select(`#${this.props.id}`)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + width / 2.17 + "," + 10 + ")");

    var layers = d3.layout.stack()(
      arr.map(function(c, num) {
        return data.map(function(d, i) {
          // return { x: d.date, y: d[c] };
          return { x: 0, y: d[c], title: d["title"][num] };
        });
      })
    );

    x.domain(
      layers[0].map(function(d) {
        return d.x;
      })
    );
    y.domain([
      0,
      d3.max(layers[layers.length - 1], function(d) {
        return d.y0 + d.y;
      })
    ]).nice();

    var layer = svg
      .selectAll(".layer")
      .data(layers)
      .enter()
      .append("g")
      .attr("class", "layer")
      .style("fill", function(d, i) {
        return colors[i];
      });

    var rectangleHeights = [];
    layer
      .selectAll("rect")
      .data(function(d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("x", function(d) {
        return x(d.x);
      })
      .attr("y", function(d) {
        return y(d.y + d.y0);
      })
      .attr("height", function(d) {
        let x = y(d.y0) - y(d.y + d.y0);
        rectangleHeights.push(x);
        return x;
      })
      // .attr("width", x.rangeBand() - 1)
      .attr("width", "150")
      .append("title")
      .text(d => `${moneyFormatter(d.y)}`);

    // legend
    var count = 0;
    var text_count = 0;

    var legend = svg
      .selectAll(".legend")
      .data(layers)
      .enter()
      .append("g")
      .attr("class", function(d, i) {
        return `legend`;
      })
      .attr("id", function(d, i) {
        return `${layers[i][0]["title"].split(" ")[0]}`;
      })
      .style("fill", "#9c9c9c");
    legend
      .selectAll("circle")
      .data(function(d) {
        return d;
      })
      .enter()
      .append("circle")
      // .attr("cx", (x.rangeBand() - 1) / 2)
      .attr("cx", 150 / 2)
      .attr("cy", function(d, i) {
        return y(d.y + d.y0) / 2 + y(d.y0) / 2;
      })
      .attr("r", "5");

    legend
      .selectAll("line")
      .data(d => d)
      .enter()
      .append("line")
      .attr("x1", 150 / 2)
      .attr("y1", function(d, i) {
        return y(d.y + d.y0) / 2 + y(d.y0) / 2;
      })
      .attr("x2", function(d, i) {
        let x = count % 2 == 0 ? "200" : "-50";
        count++;
        return x;
      })
      .attr("y2", function(d, i) {
        return y(d.y + d.y0) / 2 + y(d.y0) / 2;
      })
      .attr("stroke", "#9c9c9c")
      .attr("stroke-width", "3");

    legend
      .selectAll("text")
      .data(d => d)
      .enter()
      .append("text")
      .attr("x", function(d, i) {
        let x =
          text_count % 2 == 0 ? "205" : d.title.length <= 15 ? "-185" : "-260";
        text_count++;
        return x;
      })
      .attr("y", function(d, i) {
        return y(d.y + d.y0) / 2 + y(d.y0) / 2 + 5;
      })
      .text(function(d) {
        let txt = `${d.title} (${(d.y / 1000).toFixed(2)}K)`;
        return txt;
      })
      .attr("fill", "#333333");

    //  outer lines
    var outerLine = svg
      .selectAll(".outerLine")
      .data(layers)
      .enter()
      .append("g")
      .attr("class", "outerLine")
      .style("fill", "#9c9c9c");

    outerLine
      .selectAll("line")
      .data(d => {
        return d;
      })
      .enter()
      .append("line");

    // removing outer line and text if value is 0
    if (layers.length) {
      layers.map(function(d, i) {
        if (d[0]["y"] === 0) {
          // d3.selectAll(`${d[0]["title"].split(" ")[0]}`).remove()
          $(`#${d[0]["title"].split(" ")[0]}`).empty();
        }
      });
    }
    svg
      .append("g")
      .attr("class", "axis axis-x_stackedBar")
      .attr("transform", `translate(${-width / 2.4},` + height + ")")
      .call(xAxis);

    svg
      .append("g")
      .attr("class", "axis axis-y_stackedBar")
      .attr(
        "transform",
        "translate(" +
          -width / 2.4 +
          `,${height - rectangleHeights.reduce((a, b) => a + b)})`
      )
      .style("stroke-dasharray", "5 5")
      .call(yAxis);

    // svg
    //   .append("g")
    //   .attr("class", "outerIncomeText")
    //   .attr("transform", `translate(-200,` + -5 + ")")
    //   .append("text")
    //   .text(`INCOME TARGET : $${this.props.annualIncomeNeeded / 1000}K`);
  };
  render() {
    return <div id={this.props.id}></div>;
  }
}

export default connect(
  ({
    retirement: {
      rig: {
        accumulation: { annualIncomeNeeded }
      }
    }
  }) => ({ annualIncomeNeeded }),
  null
)(StackedBar);



// WEBPACK FOOTER //
// ./src/components/d3Components/StackedBarChart/single_stackedBar.jsx